// Single source of truth for booking / extension / cancellation policy copy.
// Update this file to change wording across the app.

export const CANCELLATION_POLICY = [
  {
    window: 'More than 12 clinic working hours before',
    outcome: 'Full refund',
    tone: 'positive',
  },
  {
    window: 'Between 6 – 12 clinic working hours before',
    outcome: '1 free reschedule (no refund)',
    tone: 'neutral',
  },
  {
    window: 'Less than 6 clinic working hours before',
    outcome: 'No refund',
    tone: 'warning',
  },
  {
    window: 'Medical / family emergency',
    outcome: 'Therapist-discretion waiver — request emergency waiver while cancelling',
    tone: 'info',
  },
];

export const NO_SHOW_POLICY =
  '15-minute grace period after the scheduled start time. The session end time is not extended.';

export const EXTENSION_POLICY =
  'Sessions can be extended in 15-minute bundles. Pricing is shown live based on session type. Payment is required to activate the extension.';

export const CLINIC_HOURS_DEFAULT = {
  start_time: '09:00',
  end_time: '18:00',
  working_days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  timezone: 'Asia/Kolkata',
};

// Maps the booking UI's "tier" labels to the backend pricing taxonomy
// (session_type + duration_minutes consumed by /api/pricing/calculate).
export const BOOKING_TIERS = [
  {
    code: 'chat-30',
    label: 'Chat (30 min)',
    description: 'Text-only chat with a counsellor',
    session_type: 'chat',
    duration_minutes: 30,
  },
  {
    code: 'voice-30',
    label: 'Voice (30 min)',
    description: 'Voice call with a counsellor',
    session_type: 'voice_call',
    duration_minutes: 30,
  },
  {
    code: 'tele-30',
    label: 'Tele-session (30 min)',
    description: 'Video session with a counsellor',
    session_type: 'tele_session',
    duration_minutes: 30,
  },
  {
    code: 'tele-40',
    label: 'Tele-session (40 min)',
    description: 'Longer video session — for deeper therapy work',
    session_type: 'tele_session',
    duration_minutes: 40,
  },
];
